import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Keyboard } from "swiper/modules";
import "swiper/css";

const advantagesData = [
  {
    id: 1,
    title: "BESPOKE INVESTMENT STRATEGIES",
    desc: "Every portfolio is structured to reflect your ambitions, risk philosophy, and long-term vision - ensuring alignment at every stage while capturing asymmetric opportunities.",
    image: "/images/advantages/1.avif",
  },
  {
    id: 2,
    title: "SELECTIVE CLIENTELE",
    desc: "We partner with a limited number of clients to ensure depth, focus, and personalised execution - the kind of attention a scaled approach simply cannot offer.",
    image: "/images/advantages/2.avif",
  },
  {
    id: 3,
    title: "DEDICATED RELATIONSHIP MANAGEMENT",
    desc: "One point of contact. Continuous alignment, discretion, and proactive guidance as your priorities evolve.",
    image: "/images/advantages/3.avif",
  },
  {
    id: 4,
    title: "INSTITUTIONAL GRADE RESEARCH",
    desc: "Your have access to a researen ecosystem defined by depth and discipline - transforming complex market movements across ossel classes into clear actionable convicton.",
    image: "/images/advantages/4.avif",
  },
  {
    id: 5,
    title: "STRATEGY LED ADVISORY",
    desc: "Decisions driven by active market practitioners, not theoretical models - bringing agility and real-time relevance to every mandate.",
    image: "/images/advantages/5.avif",
  },
  {
    id: 6,
    title: "ADVANCED EXECUTION INFRASTRUCTURE",
    desc: "Engineered for speed, stability, and precision - minimising slippage and optimising trade efficiency at every level.",
    image: "/images/advantages/6.avif",
  },
  {
    id: 7,
    title: "INTELLIGENT RISK OVERSIGHT",
    desc: "Continuous monitorina, strategic alerts, and disciplined frameworks work in tandem to safeguard your portfolio while optimising perrormance in aynomic market concitions.",
    image: "/images/advantages/7.avif",
  },
  {
    id: 8,
    title: "SEAMLESS DIGITAL ONBOARDING",
    desc: "A refined onboarding experience that is swift, secure, and discreet-designed to provide ellor loss access without compromising regulatory integrity.",
    image: "/images/advantages/8.avif",
  },
  {
    id: 9,
    title: "CAPITAL PRESERVATION POLICY",
    desc: "Risk-first, always. We focus on protecting your capital during volatility while selectively capturing high-conviction opportunities for long-term compounding.",
    image: "/images/advantages/9.avif",
  },
  {
    id: 10,
    title: "CURATED CLIENT EXPERIENCE",
    desc: "Exclusive insights, curated Interactions, and access to network designed to grow your financial and intellectual capital.",
    image: "/images/advantages/10.avif",
  },
  {
    id: 11,
    title: "UNCOMPROMISING TRUST AND SECURITY",
    desc: "Governance and integrity at every layer - ensuring the highest standards of confidentiality, compliance, and data protection.",
    image: "/images/advantages/11.avif",
  },
  {
    id: 12,
    title: "DISCERNING & HOLISTIC APPROACH",
    desc: "Built for discerning investors, entrepreneurs, and family offices who value control, clarity, and conviction - combining institutiond expertise with a deeply personalised weaken exporterse.",
    image: "/images/advantages/12.avif",
  },
];

const Advantages = () => {
  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <section className="advantages container">
      <div className="advantages-head">
        <h3 data-aos="fade-up">
          Engineered For Precision <br /> Designed For Enduring Wealth
        </h3>
        <span data-aos="fade">DISCOVER WHAT SETS US APART</span>
      </div>

      {/* Slider */}
      <div className="row">
        <div className="col-lg-12">
          <Swiper
            modules={[A11y, Keyboard]}
            a11y={{
              enabled: true,
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
            }}
            keyboard={{ enabled: true }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            loop={true}
            spaceBetween={35}
            slidesPerView={2}
            speed={500}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1000: { slidesPerView: 2 },
            }}
            className="advantages-slider"
          >
            {advantagesData.map((card, index) => (
              <SwiperSlide key={card.id}>
                <div
                  className="advantage-card"
                  style={{ "--bg-image": `url(${card.image})` }}
                >
                  <span>{card.title}</span>
                  <p>{card.desc}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="slider-navigation">
            <button
              id="tab-prev"
              onClick={handlePrev}
              aria-label="Previous Slide"
            >
              <img
                src="/images/tab-slider/arrow.png"
                alt=""
                style={{ rotate: "180deg" }}
              />
            </button>
            <button id="tab-next" onClick={handleNext} aria-label="Next Slide">
              <img src="/images/tab-slider/arrow.png" alt="" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
